import { EditChatTabNames } from '@choco-admin/types';
import { Tabs, Tab } from '@heroui/react';
import React from 'react';
import { FiUsers, FiSettings, FiMessageSquare } from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';

interface EditChatTabsProps {
  activeTab: EditChatTabNames;
}

// NOTE (issue #124): There is intentionally no Order Guide tab here. The legacy
// Order Guide editor is retired — do NOT re-add an `ORDER_GUIDE` tab or port the
// old product CRUD / batch-upload UI as "parity". Future Portal Order Guide
// content will arrive via a separate Retool-backed read surface. Stale
// `#order-guide` hashes fall back to Participants (see resolveEditChatTab).
export const EditChatTabs: React.FC<EditChatTabsProps> = ({ activeTab }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleTabChange = (key: React.Key) => {
    navigate(`${location.pathname}#${String(key)}`, { replace: true });
  };

  return (
    <Tabs
      selectedKey={activeTab}
      onSelectionChange={handleTabChange}
      variant="underlined"
      classNames={{
        tabList:
          'gap-6 w-full relative rounded-none p-0 border-b border-divider',
        cursor: 'w-full bg-primary',
        tab: 'max-w-fit px-0 h-12',
        tabContent: 'group-data-[selected=true]:text-primary',
      }}
    >
      <Tab
        key={EditChatTabNames.PARTICIPANTS}
        title={
          <div className="flex items-center gap-2">
            <FiUsers size={16} />
            <span>Participants</span>
          </div>
        }
      />
      <Tab
        key={EditChatTabNames.SETTINGS}
        title={
          <div className="flex items-center gap-2">
            <FiSettings size={16} />
            <span>Settings</span>
          </div>
        }
      />
      <Tab
        key={EditChatTabNames.CHAT_HISTORY}
        title={
          <div className="flex items-center gap-2">
            <FiMessageSquare size={16} />
            <span>Chat History</span>
          </div>
        }
      />
    </Tabs>
  );
};
